import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { ShowMoreBlock } from '../../';

/* eslint-disable */
export const CommentList = styled.div`
  padding: 21px 15px;
  border-top: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 0 0 ${({ theme }) => `${theme.borderRadius} ${theme.borderRadius}`};
  background-color: #fff;

  ${minMediaQueries.phablet`
    padding: 21px 30px;
  `};

  ${/*sc-sel*/ ShowMoreBlock} {
    margin-bottom: 6px;
  }
`;
/* eslint-enable */
